import { Card, Stack, Alert } from '@mui/material'
import FloodSummary from './flood/FloodSummary'
import FloodEventMetrics from './flood/FloodEventMetrics'
import FloodDepth from './flood/FloodDepth'
import type { MetricDataFilters } from '../../../hooks/analytics'
import type { AdaptationView, CanonicalPeriod, EmissionTier } from '../common'

type PropertyFloodProps = {
  propertyId: number
  emissionTier: EmissionTier
  selectedPeriod: CanonicalPeriod
  view?: AdaptationView
  filters?: MetricDataFilters | null
}

const PropertyFlood = ({ propertyId, emissionTier, selectedPeriod, view, filters }: PropertyFloodProps) => {
  if (!propertyId) return <Alert severity="info">Select a property to view flood metrics.</Alert>

  return (
    <Stack spacing={4}>
      <Card sx={{ p: 3 }}>
        <FloodSummary
          propertyId={propertyId}
          emissionTier={emissionTier}
          selectedPeriod={selectedPeriod}
          view={view}
          filters={filters}
        />
      </Card>
      <Card sx={{ p: 3 }}>
        <FloodEventMetrics propertyId={propertyId} emissionTier={emissionTier} filters={filters} view={view} />
      </Card>
      <Card sx={{ p: 3 }}>
        <FloodDepth propertyId={propertyId} emissionTier={emissionTier} filters={filters} view={view} />
      </Card>
    </Stack>
  )
}

export default PropertyFlood
